<template>
  <div class="social-auth-wrapper" />
</template>

<script>
import { mapActions } from 'vuex';

export default {
  created() {
    this.setLoading(true);

    // cancel social auth
    const query = Object.keys(this.$route.query);
    const errors = ['error_code', 'error'];
    errors.forEach((element) => {
      if (query.includes(element)) this.$router.push('/login');
    });

    const socialName = this.$route.params.social;
    const params = this.$route.query;
    this.$store.dispatch('loginSocial', { socialName, params })
      .then((response) => {
        this.setLoading(false);
        if (response.data.success) {
          this.$router.push('/');
        }
      });
  },

  methods: {
    ...mapActions({
      setLoading: 'SET_LOADING',
    }),
  },

};
</script>

<style scoped>
  .social-auth-wrapper {
    height: 100vh;
  }
</style>
